import React from 'react';
import Switch from '@material-ui/core/Switch';
import { makeStyles } from '@material-ui/core/styles';
import Table from './table';
import Data from './masterJson.json'
const useStyles = makeStyles({
  table: {
    width: '100%',
    borderCollapse: 'collapse',
  },
  nestedTable: {
    marginLeft: '20px',
    borderCollapse: 'collapse',
  },
  th: {
    border: '1px solid black',
    padding: '8px',
    textAlign: 'left',
  },
  td: {
    border: '1px solid black',
    padding: '8px',
    textAlign: 'left',
  },
});

const summaryConfigJSON = {
  "title": "Usage Summary",
  "indexKey":"gtsInvoiceitems",
  "fields": [
    {"label": "Application Context", "key": "applicationcontext"},
    {"label": "Role", "key": "roleId"},
    {"label": "Access", "key": "accessPersmission"}
  ],
  "subFields": [
    {"label": "Application Context", "key": "applicationcontext"},
    {"label": "Role", "key": "roleId"},
    {"label": "Access", "key": "accessP"},
    {"label": "Authorize", "key": "authorizeP"},
    {"label": "Delete", "key": "deleteP"},
    {"label": "Save", "key": "saveP"},
    {"label": "Updates", "key": "updateP"}
  ]
};

const NestedTable = ({ updatePermissions }) => {
  const classes = useStyles();

  const renderTable = (permissions) => {
    return (
      <table className={classes.table}>
        <thead>
          <tr>
            <th className={classes.th}>Application Context</th>
            <th className={classes.th}>Role</th>
            <th className={classes.th}>Authorize</th>
            <th className={classes.th}>Delete</th>
            <th className={classes.th}>List</th>
            <th className={classes.th}>Save</th>
            <th className={classes.th}>Updates</th>
            {permissions.some(p => p.isPrent === 1) && <th className={classes.th}>Access</th>}
          </tr>
        </thead>
        <tbody>
          {permissions.map(permission => (
            <React.Fragment key={permission.id}>
              <tr>
                <td className={classes.td}>{permission.applicationcontext}</td>
                <td className={classes.td}>{permission.roleId}</td>
                <td className={classes.td}>
                  <Switch
                    checked={permission.authorizeP === 1}
                    disabled={permission.accessPersmission !== 1}
                    onChange={e =>
                      updatePermissions(permission.id, 'authorizeP', e.target.checked ? 1 : 0)
                    }
                  />
                </td>
                <td className={classes.td}>
                  <Switch
                    checked={permission.deleteP === 1}
                    disabled={permission.accessPersmission !== 1}
                    onChange={e =>
                      updatePermissions(permission.id, 'deleteP', e.target.checked ? 1 : 0)
                    }
                  />
                </td>
                <td className={classes.td}>
                  <Switch
                    checked={permission.listP === 1}
                    disabled={permission.accessPersmission !== 1}
                    onChange={e =>
                      updatePermissions(permission.id, 'listP', e.target.checked ? 1 : 0)
                    }
                  />
                </td>
                <td className={classes.td}>
                  <Switch
                    checked={permission.saveP === 1}
                    disabled={permission.accessPersmission !== 1}
                    onChange={e =>
                      updatePermissions(permission.id, 'saveP', e.target.checked ? 1 : 0)
                    }
                  />
                </td>
                <td className={classes.td}>
                  <Switch
                    checked={permission.updatesP === 1}
                    disabled={permission.accessPersmission !== 1}
                    onChange={e =>
                      updatePermissions(permission.id, 'updatesP', e.target.checked ? 1 : 0)
                    }
                  />
                </td>
                {permission.isPrent === 1 && (
                  <td className={classes.td}>
                    <Switch
                      checked={permission.accessPersmission === 1}
                      onChange={e =>
                        updatePermissions(permission.id, 'accessPersmission', e.target.checked ? 1 : 0)
                      }
                    />
                  </td>
                )}
              </tr>
              {permission.accessPersmission === 1 && permission.children && permission.children.length > 0 && (
                <tr>
                  <td colSpan="8">
                    <div className={classes.nestedTable}>
                      {renderTable(permission.children)}
                    </div>
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    );
  };

  // Function to create a nested structure from flat data
  const createNestedData = (data) => {
    const map = new Map();
    const roots = [];

    data.forEach(item => {
      map.set(item.id, { ...item, children: [] });
    });

    data.forEach(item => {
      if (item.prentContext === null || item.prentContext === "") {
        roots.push(map.get(item.id));
      } else {
        const parent = data.find(parentItem => parentItem.applicationcontext === item.prentContext);
        if (parent) {
          map.get(parent.id).children.push(map.get(item.id));
        }
      }
    });

    return roots;
  };

  const nestedPermissions = createNestedData(Data);
// console.log(nestedPermissions)
  return (
    <div className='main'>
      {/* {renderTable(nestedPermissions)} */}
      <Table data={nestedPermissions}/>
    </div>
  );
};

export default NestedTable;

